/**
 * Converts a money amount to integer cents.
 *
 * Use this before splitting or subtracting money so the arithmetic stays on
 * whole cents and does not drift.
 *
 * @param amount The money amount. `null` and `undefined` are treated as `0`.
 * @returns The amount in cents, rounded half-up.
 * @example
 * ```ts
 * toCents(10.005); // 1001
 * toCents(null); // 0
 * ```
 */
export function toCents(amount: number | null | undefined): number {
  return Math.round(Number(amount ?? 0) * 100);
}
